import React from 'react'

export const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [maskId] = React.useState(() => `mask0_${Date.now()}`)
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d='M7.59625 14.1667C7.21264 14.1667 6.89236 14.0382 6.63542 13.7812C6.37847 13.5243 6.25 13.204 6.25 12.8204V3.84625C6.25 3.46264 6.37847 3.14236 6.63542 2.88542C6.89236 2.62847 7.21264 2.5 7.59625 2.5H14.0704C14.454 2.5 14.7743 2.62847 15.0313 2.88542C15.2882 3.14236 15.4167 3.46264 15.4167 3.84625V12.8204C15.4167 13.204 15.2882 13.5243 15.0313 13.7812C14.7743 14.0382 14.454 14.1667 14.0704 14.1667H7.59625ZM7.59625 13.3333H14.0704C14.1988 13.3333 14.3163 13.2799 14.4231 13.1731C14.5299 13.0663 14.5833 12.9488 14.5833 12.8204V3.84625C14.5833 3.71792 14.5299 3.60035 14.4231 3.49354C14.3163 3.38674 14.1988 3.33333 14.0704 3.33333H7.59625C7.46792 3.33333 7.35035 3.38674 7.24354 3.49354C7.13674 3.60035 7.08333 3.71792 7.08333 3.84625V12.8204C7.08333 12.9488 7.13674 13.0663 7.24354 13.1731C7.35035 13.2799 7.46792 13.3333 7.59625 13.3333ZM5.09625 16.6667C4.71264 16.6667 4.39236 16.5382 4.13542 16.2812C3.87847 16.0243 3.75 15.7041 3.75 15.3206V5.92958C3.75 5.81097 3.78979 5.71187 3.86937 5.63229C3.94896 5.55271 4.04806 5.51292 4.16667 5.51292C4.28528 5.51292 4.38438 5.55271 4.46396 5.63229C4.54354 5.71187 4.58333 5.81097 4.58333 5.92958V15.3206C4.58333 15.4488 4.63674 15.5663 4.74354 15.6731C4.85035 15.7799 4.96792 15.8333 5.09625 15.8333H11.9871C12.1057 15.8333 12.2048 15.8731 12.2844 15.9527C12.364 16.0323 12.4038 16.1314 12.4038 16.25C12.4038 16.3686 12.364 16.4677 12.2844 16.5473C12.2048 16.6269 12.1057 16.6667 11.9871 16.6667H5.09625Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
